import { Component, OnInit, Input } from '@angular/core';
import { HttpRequestsService } from 'src/app/services/http-requests.service';
import { KeycloakService } from 'keycloak-angular';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Location } from '@angular/common';

@Component({
  selector: 'app-city-dna',
  templateUrl: './city-dna.component.html',
  styleUrls: ['./city-dna.component.scss'],
})
export class CityDNAComponent implements OnInit {
  @Input("edit") edit: boolean = true;
  public edited: boolean = false;
  public allowed: boolean;
  public city = history.state.city;
  public comittee: string;
  public mission: string;
  public objectives: string;
  public orientation = [];
  public groups: string;
  public data: any = [];
  public actionCat: any = [];
  public actions = [];
  public priorities = [];
  public impacts = [];
  public categories: string[];
  public actionsByCategory: { [key: string]: any[] } = {};

  constructor(private keycloak: KeycloakService, private req: HttpRequestsService<any>, private _location: Location) { }

  ngOnInit(): void {
    if (this.keycloak.getUserRoles().includes('MODERATOR')) {
      this.allowed = true;
    } else {
      const keycloakInstance = this.keycloak.getKeycloakInstance();
      if (keycloakInstance.authenticated) {
        this.keycloak.loadUserProfile().then(profile => {
          if (profile['attributes'].City[0] == this.city) {
            this.allowed = true;
          } else {
            this.allowed = false;
          };
        });
      } else {
        this.allowed = false;
      }
    }

    this.req.getCities().subscribe((res) => {
      res.forEach(element => {
        if (element.City === this.city) {
          this.comittee = element.Comittee;
          this.mission = element.Mission;
          this.objectives = element.Objectives;
          this.groups = element.Target_groups;
          this.orientation = element.Orientation
          this.impacts = element.Impacts ;
        }
      });
      console.log(this.impacts)
      this.req.getCityDna(this.city).subscribe((res) => {
        this.data = res;
        for (const item of this.data) {
          const category = item.Action_Cat;
          const action = item.Action;
          const nutrition = item.Nutrition;
          const climate = item.Climate;
          const circularity = item.Circularity;
          const innovation = item.Innovation;
          const existingCategory = this.actions.find(a => a.category === category);
          if (existingCategory) {
            existingCategory.actions.push({ action, nutrition, climate, circularity, innovation });
          } else {
            this.actions.push({ category, actions: [{ action, nutrition, climate, circularity, innovation }] });
          }
        }
      });
    });
  }

  getCategoryImage(category: string): string {
    switch (category) {
      case 'CIA-FOOD CONSUMER':
        return '../../../../../../assets/img/consumption.png';
      case 'DIA-FOOD DISTRIBUTION':
        return '../../../../../../assets/img/distribution.png';
      case 'GIA-FOOD GOVERNANCE':
        return '../../../../../../assets/img/governance.png';
      case 'PIA-FOOD PRODUCTION AND PROCESSING':
        return '../../../../../../assets/img/production.png';
      case 'WIA-FOOD WASTE':
        return '../../../../../../assets/img/waste.png';
      default:
        return '';
    }
  }

  onInfo() {
    let cityParam: string;
    if (this.city === 'Nilufer-Bursa') {
      cityParam = 'Nilufer'
    }
    else {
      cityParam = this.city;
    }
    window.open(`https://fusilli-project.eu/cities/${cityParam}/`, '_blank');
  }

  onFocus() {
    this.edited = true;
  }

  isOdd(index: number): boolean {
    return index % 2 === 0;
  }

  getCategoryClass(category: string): string {
    switch (category) {
      case 'GIA-FOOD GOVERNANCE':
        return 'gia';
      case 'CIA-FOOD CONSUMER':
        return 'cia';
      case 'DIA-FOOD DISTRIBUTION':
        return 'dia';
      case 'PIA-FOOD PRODUCTION AND PROCESSING':
        return 'pia';
      case 'WIA-FOOD WASTE':
        return 'wia';
      default:
        return '';
    }
  }
  onComitteeChange(element) {
    this.comittee = element;
  }
  onMissionChange(element) {
    this.mission = element;
  }
  onObjectivesChange(element) {
    this.objectives = element;
  }
  onGroupsChange(element) {
    this.groups = element;
  }

  onSave() {
    let data = {
      comittee: this.comittee,
      mission: this.mission,
      objectives: this.objectives,
      target_groups: this.groups
    }

    let dataObj = JSON.stringify(data)
    this.req.updateDNA(this.city, dataObj).subscribe(res => { })

    if (this.edited) {
      Swal.fire(
        'Done!',
        'ID updated!',
        'success'
      )
    }
    this._location.back();
  }
}
